/* ============================================================
   CLIM BOUTIQUE — theme.js
   ============================================================ */

'use strict';

const routes = (window.theme && window.theme.routes) || {
  cart_add_url: '/cart/add',
  cart_change_url: '/cart/change',
  cart_url: '/cart'
};


/* ---- Header height → sticky tabs offset ---- */
(function initHeaderHeight() {
  function update() {
    var h = 0;
    document.querySelectorAll('.announcement-bar, .site-header').forEach(function(el) {
      var rect = el.getBoundingClientRect();
      if (rect.height > 0) h += rect.height;
    });
    if (h > 0) document.documentElement.style.setProperty('--header-h', h + 'px');
  }
  update();
  window.addEventListener('resize', update);
  window.addEventListener('load', update);
})();

/* ---- Cart count update ---- */
(function initCartCount() {
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
    } catch (e) {
      // silent
    }
  }
  updateCartCount();
})();

/* ---- Add to cart (product card quick add) ---- */
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-quick-add]');
  if (!btn) return;

  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  btn.disabled = true;
  const originalContent = btn.innerHTML;
  btn.innerHTML = '<span class="spinner"></span>';

  try {
    const res = await fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    });

    if (res.ok) {
      showToast('✓ Produit ajouté au panier', 'success');
      // refresh count
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        el.hidden = false;
      });
    } else {
      showToast('Erreur lors de l\'ajout au panier', 'error');
    }
  } catch (err) {
    showToast('Erreur réseau', 'error');
  } finally {
    btn.disabled = false;
    btn.innerHTML = originalContent;
  }
});

/* ---- Product page: quantity selector ---- */
(function initQtySelector() {
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.closest('.quantity-selector')?.querySelector('.qty-input');
      if (!input) return;
      let val = parseInt(input.value) || 1;
      if (btn.dataset.action === 'increase') val = Math.min(val + 1, 99);
      if (btn.dataset.action === 'decrease') val = Math.max(val - 1, 1);
      input.value = val;
    });
  });
})();

/* ---- Product page: gallery thumbnails ---- */
(function initGallery() {
  const thumbs = document.querySelectorAll('.product-thumb');
  const mainImg = document.querySelector('.product-gallery-main img');
  if (!thumbs.length || !mainImg) return;

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const newSrc = thumb.dataset.src;
      if (newSrc) {
        mainImg.style.opacity = '0';
        mainImg.style.transition = 'opacity 0.2s';
        setTimeout(() => {
          mainImg.src = newSrc;
          mainImg.style.opacity = '1';
        }, 150);
      }
    });
  });
})();

/* ---- Product page: variant selection ---- */
(function initVariants() {
  const variantBtns = document.querySelectorAll('.variant-btn');
  variantBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.dataset.group;
      document.querySelectorAll(`.variant-btn[data-group="${group}"]`).forEach(b => {
        b.classList.remove('active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('active');
      btn.setAttribute('aria-pressed', 'true');

      const variantId = btn.dataset.variantId;
      const priceEl = document.querySelector('[data-variant-price]');
      const price = btn.dataset.price;
      const comparePrice = btn.dataset.comparePrice;

      if (priceEl && price) {
        priceEl.textContent = formatMoney(parseInt(price));
      }

      const addToCartBtn = document.querySelector('[data-add-to-cart]');
      if (addToCartBtn && variantId) {
        addToCartBtn.dataset.variantId = variantId;
        addToCartBtn.disabled = btn.dataset.available === 'false';
        if (btn.dataset.available === 'false') {
          addToCartBtn.textContent = 'Rupture de stock';
        } else {
          addToCartBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg> Ajouter au panier';
        }
      }
    });
  });
})();

/* ---- Add to cart (product page) ---- */
(function initAddToCart() {
  const form = document.querySelector('[data-product-form]');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const btn = form.querySelector('[data-add-to-cart]');
    const variantId = btn?.dataset.variantId || form.querySelector('[name="id"]')?.value;
    const qty = parseInt(form.querySelector('.qty-input')?.value) || 1;

    if (!variantId) return;

    const originalHtml = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<span class="spinner"></span> Ajout en cours...';

    try {
      const res = await fetch(routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty }),
      });

      if (res.ok) {
        showToast('✓ Produit ajouté au panier !', 'success');
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        document.querySelectorAll('[data-cart-count]').forEach(el => {
          el.textContent = cart.item_count;
          el.hidden = false;
        });
      } else {
        const err = await res.json();
        showToast(err.description || 'Erreur lors de l\'ajout', 'error');
      }
    } catch (err) {
      showToast('Erreur réseau', 'error');
    } finally {
      btn.disabled = false;
      btn.innerHTML = originalHtml;
    }
  });
})();

/* ---- BTU Filter (collection page) ---- */
(function initBtuFilter() {
  const filterChips = document.querySelectorAll('.filter-chip[data-tag]');
  if (!filterChips.length) return;

  filterChips.forEach(chip => {
    chip.addEventListener('click', () => {
      const tag = chip.dataset.tag;
      const collectionUrl = chip.dataset.collectionUrl || window.location.pathname;

      if (chip.classList.contains('active')) {
        // deselect: go back to base collection
        window.location.href = collectionUrl;
      } else {
        window.location.href = collectionUrl + '/' + tag;
      }
    });
  });
})();

/* ---- Filter sidebar toggle (mobile) ---- */
(function initFilterToggle() {
  const toggleBtn = document.querySelector('[data-filter-toggle]');
  const sidebar = document.querySelector('.filter-sidebar');
  if (!toggleBtn || !sidebar) return;

  toggleBtn.addEventListener('click', () => {
    sidebar.classList.toggle('is-open');
    const isOpen = sidebar.classList.contains('is-open');
    toggleBtn.setAttribute('aria-expanded', isOpen);
  });
})();

/* ---- Sort select ---- */
(function initSort() {
  const sortSelect = document.querySelector('[data-sort-select]');
  if (!sortSelect) return;
  sortSelect.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortSelect.value);
    window.location.href = url.toString();
  });
})();

/* ---- Cart page: remove item ---- */
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-remove-line]');
  if (!btn) return;

  const line = btn.dataset.removeLine;
  try {
    const res = await fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line), quantity: 0 }),
    });
    if (res.ok) window.location.reload();
  } catch (err) {
    showToast('Erreur lors de la suppression', 'error');
  }
});

/* ---- Cart page: update quantity ---- */
document.addEventListener('change', async (e) => {
  const input = e.target.closest('[data-cart-qty]');
  if (!input) return;

  const line = input.dataset.cartQty;
  const qty = parseInt(input.value);
  if (isNaN(qty) || qty < 0) return;

  try {
    await fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line), quantity: qty }),
    });
    window.location.reload();
  } catch (err) {
    showToast('Erreur mise à jour panier', 'error');
  }
});

/* ---- Newsletter form ---- */
(function initNewsletter() {
  const form = document.querySelector('[data-newsletter-form]');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const input = form.querySelector('input[type="email"]');
    const btn = form.querySelector('button[type="submit"]');
    if (!input?.value) return;

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Inscription...';

    // Shopify customer accept marketing via contact form
    try {
      const formData = new FormData();
      formData.append('contact[email]', input.value);
      formData.append('contact[tags]', 'newsletter');
      formData.append('form_type', 'customer');

      await fetch('/contact', { method: 'POST', body: formData });
      showToast('✓ Inscription réussie ! Merci.', 'success');
      input.value = '';
    } catch (err) {
      showToast('Erreur, veuillez réessayer.', 'error');
    } finally {
      btn.disabled = false;
      btn.textContent = originalText;
    }
  });
})();

/* ---- Utility: format money ---- */
function formatMoney(cents) {
  return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
}

/* ---- Utility: toast notification ---- */
let toastTimeout;
function showToast(message, type = 'success') {
  let toast = document.querySelector('.toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.className = 'toast';
    document.body.appendChild(toast);
  }

  toast.className = `toast toast-${type}`;
  toast.innerHTML = `<span class="toast-icon">${type === 'success' ? '✓' : '✕'}</span> ${message}`;

  clearTimeout(toastTimeout);
  requestAnimationFrame(() => {
    toast.classList.add('show');
    toastTimeout = setTimeout(() => toast.classList.remove('show'), 3500);
  });
}

/* ---- Stock filter (collection page) ---- */
(function initStockFilter() {
  var chip = document.querySelector('[data-instock-chip]');
  var grid = document.querySelector('.products-grid');
  if (!chip || !grid) return;

  var active = new URLSearchParams(window.location.search).get('instock') === '1';

  function apply() {
    chip.classList.toggle('active', active);
    chip.setAttribute('aria-pressed', active ? 'true' : 'false');
    grid.classList.toggle('stock-only', active);
    var url = new URL(window.location.href);
    if (active) { url.searchParams.set('instock', '1'); } else { url.searchParams.delete('instock'); }
    history.replaceState({}, '', url.toString());
  }

  apply();
  chip.addEventListener('click', function() { active = !active; apply(); });
})();

/* ---- Scroll reveal (lightweight) ---- */
(function initReveal() {
  if (!('IntersectionObserver' in window)) return;

  const style = document.createElement('style');
  style.textContent = '.reveal{opacity:0;transform:translateY(20px);transition:opacity .5s ease,transform .5s ease}.reveal.visible{opacity:1;transform:none}';
  document.head.appendChild(style);

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.feature-card, .product-card').forEach(el => {
    el.classList.add('reveal');
    observer.observe(el);
  });
})();
